<fui-outline-button [disabled]="disabled" [ngClass]="{'disabled': disabled}" [title]="title">
    <fui-icon *ngIf="icon" [width]="12" [height]="12" [icon]="icon"></fui-icon>
</fui-outline-button>
